import React from 'react';
import "./../AdSign/AdSign.scss";
import { useAppSelector } from '../../../Redux/hooks';
import { allcontentOrConfigData } from '../../../Redux/Reducers/GlobalSlice';
import { CONTENT_OR_CONFIG_TABLE_MAPPING, LOGINLINK, REGISTERCARRIEROFFLINE, REGISTERLINK } from '../../../utils/constants';
import { getKeyValuePair } from '../../../utils/ContentOrConfigUtil';
import { adSign } from '../../../utils/validation';
import { constants } from 'buffer';
import { consumers } from 'stream';
import { EVENT, SCREEN } from '../../../utils/constants.analytics';
import { fbLogEvent } from '../../../Helpers/FirebaseHelper';

export interface IAdSignProps { };
const AdSign: React.FunctionComponent<IAdSignProps> = (props) => {
   const contentOrConfigData: any = useAppSelector(allcontentOrConfigData);
   let _role = useAppSelector((state: any) => state?.global?.role) || "";
   const contentType: string = CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.FOOTER_CONTENT_TYPE;
   const adSignData = JSON.parse(getKeyValuePair(contentOrConfigData, contentType, adSign(_role)));
   const registerCarrier = adSignData?.advertisement_resources;
   const firebaseEvent = (data: any) => {
      let parameters = { adsignData: data && data.registerCarrierData }
      let fbEvent = null;
      let fbScreen = null;
      fbEvent = EVENT.UE_AD_SIGN_DETAILS;
      fbScreen = SCREEN.AD_SIGN_DETAILS;
      fbEvent && fbScreen && fbLogEvent(fbEvent, {
         ...{ screen: fbScreen }, ...parameters
      });
   }
   return (
      <>
         {adSignData ? <div className="AdSign" data-testid="adsigndata">
            <div>
               <a href={adSignData?.advertisement_login.webLink} target="_blank" rel="noopener noreferrer">
                  <img className="LoginLogo" alt="log" src={`${process.env.PUBLIC_URL}/assets/images/login.png`} />
                  <div className="LoginText">{adSignData?.advertisement_login?.text}</div>
                  <div className="LoginText Divider"></div></a></div>
            <div>
               <a href={adSignData?.advertisement_registration.webLink} target="_blank" rel="noopener noreferrer">
                  <div className="Account">{adSignData?.advertisement_registration_header_text}</div>
                  {<img className="Registration" alt="log" src={`${process.env.PUBLIC_URL}/assets/images/registration.svg`} />}
                  <div className="RegisterNow"> {adSignData?.advertisement_registration?.text}</div></a></div>
            <div className="RegisterCarrier">{adSignData?.advertisement_resources_header_text}</div>
            {registerCarrier &&
               registerCarrier.map((data: any) =>
                  <div className="RegisterCarrieLinks">
                     <a href={data?.webLink} target="_blank" rel="noopener noreferrer" onClick={() => firebaseEvent(data.registerCarrierData)}>
                        <p><img src={data?.commonImage} alt="log" /><img src={data?.imageURL} alt="log" className="RegisterLogo" />
                           <span className={`${data?.registerCarrierData === "Book a Load" ? "RegisterTitle" : "RegisterTitle_Purchaing"}`}>{data?.registerCarrierData} </span></p>
                     </a>
                  </div>
               )
            }
         </div>
            : <div className="AdSign" data-testid="adsign">
            <div>
               <a href={LOGINLINK} target="_blank" rel="noopener noreferrer">
                  <img className="LoginLogo" alt="log" src={`${process.env.PUBLIC_URL}/assets/images/login.png`} />
                  <div className="LoginText">Login</div>
                  <div className="LoginText Divider"></div></a></div>
            <div><a href={REGISTERLINK} target="_blank" rel="noopener noreferrer">
               <div className="Account">Don't have an account?</div>
               {<img className="Registration" alt="log" src={`${process.env.PUBLIC_URL}/assets/images/registration.svg`} />}
               <div className="RegisterNow"> Register Now</div>
               <div className="RegisterCarrier">Resources for Registered Carriers</div></a></div>

            {REGISTERCARRIEROFFLINE &&
               REGISTERCARRIEROFFLINE.map((data: any) =>
                     <div className="RegisterCarrieLinks">
                        <a href={data.webLink} target="_blank" rel="noopener noreferrer">
                        <p><img src={data.image} alt="imgRect" /><img src={data.imageURL} className="RegisterLogo" alt="imgLogo" />
                           <span className="RegisterTitle">{data.registerCarrierData} </span></p>
                           </a>
                     </div>
                 
               )
            }
         </div>
         }
      </>
   )
}
export default AdSign;